
import { Vue, Component } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import SchoolSelector from '../components/school-selector.vue'
import CurrentClassSelect from '../components/current-class-select.vue'
import { faceTempleteService } from '@/api/payments/faceTempleteService'
import {
  FaceTempletePaidDtoPagedResultDto,
  UpdateFaceTempleteVipTypeInput,
  VipUpdateType,
} from '@/api/service-proxies'
import UpdateVip from './components/update-vip.vue'

import PagedListBase, { PagedRequestDto } from '@/lib/view-base/paged-list-base'
import { UserDto } from '@/api/service-proxies'
import moment from 'moment'

class PageFaceTempletePaidRequest extends PagedRequestDto {
  tenantId: number
  gradeNo!: number
  classNo!: number
  paidStatus!: number
  phoneNumber!: string
  name!: string
}

@Component({
  components: {
    Pagination,
    SchoolSelector,
    CurrentClassSelect,
    UpdateVip,
  },
})
export default class PaymentPayments extends PagedListBase<
  PageFaceTempletePaidRequest,
  FaceTempletePaidDtoPagedResultDto
> {
  request = new PageFaceTempletePaidRequest()
  selectedFaceTempletes = []
  showVipSelector = false
  created() {}

  getpage(finishCallback: Function): void {
    faceTempleteService
      .getPagedFaceTempletePaid(
        this.request.tenantId,
        this.request.gradeNo,
        this.request.classNo,
        this.request.paidStatus,
        this.request.phoneNumber,
        this.request.name,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then((result) => {
        result.items.forEach(e=>{
          e.faceTemplete.imgUrl = e.faceTemplete.imgUrl+"?auth=wkxiaolvsan";
        })
        this.list = result.items
        this.showPaging(result)
      })
      .finally(() => {
        finishCallback()
      })
  }

  currentClassChange(event: any) {
    this.request.gradeNo = event.gradeNo
    this.request.classNo = event.classNo
  }

  schoolChange(event: any) {
    this.request.tenantId = event.tenantId
  }

  paymentDetail(row: any) {
    this.$router.push({
      path: `/payment/payment-payments/payment-detail/${row.faceTemplete.id}`,
    })
  }

  vipPaymentRecord(row: any) {
    this.$router.push({
      path: `/payment/payment-payments/vip-payment-record/${row.faceTemplete.id}`,
    })
  }
  orderDetail(row: any) {
    this.$router.push({
      path: `/payment/payment-payments/order-detail/${row.faceTemplete.id}`,
    })
  }

  handleSelectionChange(row: any) {
    this.selectedFaceTempletes = row.map((p) => p.faceTemplete)
  }
  handleUpdateVip() {
    if(!this.request.tenantId){
      this.$notify.info("请先搜索学校会员数据...");
      return;
    }
    
    this.showVipSelector = true
  }

  async selectVipSuccess(form: any) {
    
    this.isTableLoading = true;
    var updateType=form.updateType;
    var vipUpdateInput=new UpdateFaceTempleteVipTypeInput();
    
    if(updateType=="0"){
       vipUpdateInput.faceTempleteIds=this.selectedFaceTempletes.map((p) => p.id);
       vipUpdateInput.vipType=form.vipType;
       vipUpdateInput.expireDate=moment(moment(form.expireDate).format('YYYY-MM-DD'));
       vipUpdateInput.vipUpdateType=VipUpdateType._0;
       vipUpdateInput.tenantId=this.request.tenantId;
    }else{
       vipUpdateInput.faceTempleteIds=[];
       vipUpdateInput.vipType=form.vipType;
       vipUpdateInput.expireDate=moment(moment(form.expireDate).format('YYYY-MM-DD'));
       vipUpdateInput.vipUpdateType=VipUpdateType._1;
       vipUpdateInput.tenantId=this.request.tenantId;
    }
    await faceTempleteService.updateFaceTempleteVipType(vipUpdateInput)

    this.$notify.success('修改成功')

    this.refresh()
  }
}
